import { render, staticRenderFns } from "./CustomModal.vue?vue&type=template&id=020b7d88&scoped=true"
import script from "./CustomModal.vue?vue&type=script&lang=js"
export * from "./CustomModal.vue?vue&type=script&lang=js"
import style0 from "./CustomModal.vue?vue&type=style&index=0&id=020b7d88&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020b7d88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('020b7d88')) {
      api.createRecord('020b7d88', component.options)
    } else {
      api.reload('020b7d88', component.options)
    }
    module.hot.accept("./CustomModal.vue?vue&type=template&id=020b7d88&scoped=true", function () {
      api.rerender('020b7d88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CustomModal.vue"
export default component.exports